import {
    Document,
    PDFViewer,
    Page as PDFPage,
    StyleSheet,
    Text as PDFText,
    View as PDFView,
    Font,
    Image as PDFImage
  } from '@react-pdf/renderer';
import { calculateAge, formatRegTime } from '../../../../../utils';
  
  Font.register({
    family: 'Roboto',
    fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'medium' }]
  });
  
  const fullScreenStyles = {
    container: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 1000,
      backgroundColor: 'white'
    }
  };
  
  const styles = StyleSheet.create({
    page: {
      // paddingTop: '5%',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    text: {
      fontSize: 10
    },
    textUnderlined: {
      fontSize: 10,
      textDecoration: 'underline',
      textDecorationColor: 'black',
      textDecorationThickness: 1.5,
      width: '120%'
    },
    heading: {
      fontSize: 14,
      fontWeight: 'bold',
      textAlign: 'center'
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      gap: 5,
      paddingBottom: '3px',
      borderBottom: '1px solid black',
      paddingTop: '155px',
      paddingRight: '30px',
      paddingLeft: '30px'
      // padding: '10px'
    },
    column: {
      width: '33%',
      display: 'flex',
      flexDirection: 'column',
      gap: 1
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 5
    },
    label: {
      fontWeight: 'bold',
      fontSize: 10
    },
    value: {
      fontSize: 10,
      fontWeight: 'normal',
      width: '65%'
    }
  });
  
  const Page = ({ style, children, ...props }) => (
    <PDFPage style={{ ...styles.page, ...style }} {...props}>
      {children}
    </PDFPage>
  );
  
  const View = ({ style, children, ...props }) => (
    <PDFView style={{ ...style }} {...props}>
      {children}
    </PDFView>
  );
  
  const Text = ({ style, content, ...props }) => (
    <PDFText style={{ ...styles.text, ...style }} {...props}>
      {content}
    </PDFText>
  );
  
  export const PatientRegistrationPdf15 = ({ data }) => {
    function formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  
    const ageString = data.age;
    const years = ageString.match(/\d+Y/);
  
    return (
      <div style={fullScreenStyles.container}>
        <PDFViewer width="100%" height="100%" showToolbar>
          <Document title={`${data.name} Registration`}>
            <Page size="A4" style={styles.page}>
              <PDFImage src="/formatasthahospital.jpeg" style={{ width: '100%', height: '100%' }} />
            </Page>
            <View style={styles.row}>
                <Text
                  content={`${data.op_no}`}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    marginTop:"20.5%",
                    marginLeft:"20%"
                  }}
                />
              </View>
              <View style={styles.row}>
            <Text
              content={data.name}
              style={{
                ...styles.value,
                textAlign: 'start',
                fontSize:"10px",
                 marginTop:"23.3%",
                 marginLeft:"20%"
                
              }}
            />
          </View>
          <View style={styles.row}>
            <Text
              content={data.guardian_name}
              style={{
                ...styles.value,
                textAlign: 'start',
                fontSize:"10px",
                 marginTop:"26%",
                 marginLeft:"20%"
                
              }}
            />
          </View>
          <View style={styles.row}>
            <Text
              content={data.department}
              style={{
                ...styles.value,
                textAlign: 'start',
                fontSize:"10px",
                 marginTop:"28.5%",
                 marginLeft:"20%"
                
              }}
            />
          </View>
          <View style={styles.row}>
            <Text
              content={data.address}
              style={{
                ...styles.value,
                textAlign: 'start',
                fontSize:"10px",
                 marginTop:"31%",
                 marginLeft:"20%"
                
              }}
            />
          </View>


          <View style={styles.row}>
            <Text
              content={formatDate(data.reg_date)}
              style={{
                ...styles.value,
                textAlign: 'start',
                fontSize:"10px",
                 marginTop:"20.5%",
                 marginLeft:"54.5%"
                
              }}
            />
          </View>

          <View style={styles.row}>
            <Text
              content={`${calculateAge(data.dob)}/${data.gender}`}
              style={{
                ...styles.value,
                textAlign: 'start',
                fontSize:"10px",
                 marginTop:"23.3%",
                 marginLeft:"54.5%"
                
              }}
            />
          </View>
         

          <View style={styles.row}>
            <Text
            content={formatDate(new Date(new Date(data.reg_date).getTime() + 7 * 24 * 60 * 60 * 1000))}
              style={{
                ...styles.value,
                textAlign: 'start',
                fontSize:"10px",
                 marginTop:"26%",
                 marginLeft:"54.5%"
            
              }}
            />
          </View>


          <View style={styles.row}>
            <Text
              content={(data.uhid)}
              style={{
                ...styles.value,
                textAlign: 'start',
                fontSize:"10px",
                 marginTop:"28.5%",
                 marginLeft:"54.5%"
                
              }}
            />
          </View>

          <View style={styles.row}>
            <Text
              content={(data.ref_by)}
              style={{
                ...styles.value,
                textAlign: 'start',
                fontSize:"10px",
                 marginTop:"31%",
                 marginLeft:"54.5%"
                
              }}
            />
          </View>
          <View style={styles.row}>
            <Text
              content={`${(data.total)}`}
              style={{
                ...styles.value,
                textAlign: 'start',
                fontSize:"10px",
                 marginTop:"31%",
                 marginLeft:"83%"
                
              }}
            />
          </View>
          </Document>
        </PDFViewer>
      </div>
    );
  };